(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sn-secure-rfq-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const allowedExtensions = ['pdf', 'step', 'stp', 'dwg'];
    const formatBytes = (bytes) => `${(bytes / 1048576).toFixed(1)} MB`;

    const initialize = (form) => {
      if (form.dataset.snRfqReady === 'true') return;
      form.dataset.snRfqReady = 'true';
      const input = form.querySelector('input[type="file"]');
      const list = form.querySelector('[data-file-list]');
      const fileStatus = form.querySelector('[data-file-status]');
      const submitStatus = form.querySelector('[data-submit-status]');
      const maxFiles = Number(form.dataset.maxFiles);
      const maxFileBytes = Number(form.dataset.maxFileBytes);
      const maxTotalBytes = Number(form.dataset.maxTotalBytes);

      const validateFiles = () => {
        const files = Array.from(input.files || []);
        const errors = [];
        let total = 0;
        list.innerHTML = '';
        files.forEach((file) => {
          total += file.size;
          const extension = file.name.split('.').pop().toLowerCase();
          if (!allowedExtensions.includes(extension)) errors.push(`${file.name}: ${form.dataset.msgFormat}`);
          if (file.size > maxFileBytes) errors.push(`${file.name}: ${form.dataset.msgFileSize}`);
          const item = document.createElement('li');
          item.textContent = `${file.name} (${formatBytes(file.size)})`;
          list.appendChild(item);
        });
        if (files.length > maxFiles) errors.push(form.dataset.msgFileCount);
        if (total > maxTotalBytes) errors.push(form.dataset.msgTotalSize);
        fileStatus.textContent = errors.length ? errors.join(' ') : (files.length ? `${files.length} ${form.dataset.msgSelected}, ${formatBytes(total)}` : '');
        fileStatus.dataset.error = errors.length ? 'true' : 'false';
        return errors.length === 0;
      };

      input.addEventListener('change', validateFiles);
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        submitStatus.dataset.error = 'false';
        if (!form.reportValidity() || !validateFiles()) return;
        const endpoint = form.dataset.endpoint.trim();
        const submitButton = form.querySelector('button[type="submit"]');
        if (!endpoint) {
          submitButton.disabled = true;
          submitStatus.textContent = form.dataset.msgSending;
          try {
            const summary = Array.from(new FormData(form).entries())
              .filter(([key, value]) => key !== 'drawings' && typeof value === 'string' && value.trim() !== '')
              .map(([key, value]) => key.replace(/_/g, ' ') + ': ' + value)
              .join('\n');
            const payload = new URLSearchParams();
            payload.set('form_type', 'contact');
            payload.set('utf8', '✓');
            payload.set('contact[email]', form.querySelector('[name="email"]')?.value || '');
            payload.set('contact[subject]', 'Silicone Nest custom project summary');
            payload.set('contact[body]', summary);
            const response = await fetch('/contact#sn-rfq-form', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }, body: payload.toString(), credentials: 'same-origin' });
            if (!response.ok) throw new Error('contact-form-error');
            submitStatus.textContent = form.dataset.msgReceived;
            form.reset();
          } catch (error) {
            submitStatus.textContent = form.dataset.msgServiceError;
            submitStatus.dataset.error = 'true';
          } finally {
            submitButton.disabled = false;
          }
          return;
        }
        submitStatus.textContent = form.dataset.msgSending;
        try {
          const response = await fetch(endpoint, { method: 'POST', body: new FormData(form), credentials: 'omit' });
          if (!response.ok) throw new Error('upload-service-error');
          submitStatus.textContent = form.dataset.msgReceived;
          form.reset();
          list.innerHTML = '';
        } catch (error) {
          submitStatus.textContent = form.dataset.msgServiceError;
          submitStatus.dataset.error = 'true';
        } finally {
          submitButton.disabled = false;
        }
      });
    };

    const initializeAll = (root = document) => root.querySelectorAll('[data-sn-rfq-form]').forEach(initialize);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll());
    else initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
